import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import
{
  BusinessGeneral,
  BusinessLocation,
  Categorias,
  Ciudades,
  Departamentos,
  Paises,
  Sociedades,
  Tipos,
} from '../types/business.types';

@Injectable({
  providedIn: 'root'
})
export class HttpService
{
  private _generalInfo = new BehaviorSubject<BusinessGeneral>(null);
  private _locationInfo = new BehaviorSubject<BusinessLocation>(null);

  public generalInfo$ = this._generalInfo
    .asObservable()
    .pipe(filter((general) => !!general));

  public locationInfo$ = this._locationInfo
    .asObservable()
    .pipe(filter((location) => !!location));

  constructor(private _http: HttpClient) { }

  getGeneralInfo()
  {
    const general = {
      sociedades: this._http.get<Sociedades[]>(
        `${environment.API_URL}/TipoSociedades/`
      ),
      tipos: this._http.get<Tipos[]>(`${environment.API_URL}/TipoNegocios/`),
      categorias: this._http.get<Categorias[]>(
        `${environment.API_URL}/CategoriaNegocios`
      ),
    };

    return forkJoin(general).pipe(tap((data) => this._generalInfo.next(data)));
  }

  getLocationInfo(): Observable<BusinessLocation>
  {
    const location = {
      paises: this._http.get<Paises[]>(`${environment.API_URL}/Paises/`),
      departamentos: this._http.get<Departamentos[]>(
        `${environment.API_URL}/Departamentos/1`
      ),
      ciudades: this._http.get<Ciudades[]>(`${environment.API_URL}/Ciudades/1`),
    };

    return forkJoin(location).pipe(
      tap((data) => this._locationInfo.next(data))
    );
  }
}
